<template>
<div class="chapter">
<div class="inner_page">
<p class="SP" id="address"> </p>
<p class="CT"><span href="#/xhtml/contents#c_address" title="Link target outside of Sample">ADDRESS TO READERS</span></p>
<p class="TNI">This book, based upon the life of the artist Robert Seymour and the extraordinary events surrounding the creation of Charles Dickens’s first novel, <span class="ePub-I">The Pickwick Papers</span>, departs, at certain points, from the ‘accepted’ origin of <span class="ePub-I">Pickwick</span>, as put forward by Dickens and his publisher Edward Chapman. It does so for a good reason.</p>
<p class="TX">The accepted origin is not true.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// address.vue?7afd12ad